var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,attrs:{"id":"app"}},[_c('Icons'),_c('router-view'),_c('CRRLogo',{staticClass:"crr-logo"}),_c('portal-target',{staticClass:"modals-portal",attrs:{"name":"modals"}}),_c('portal-target',{staticClass:"richtext-portal",attrs:{"name":"richtext"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }